module.exports = __webpack_public_path__ + "img/bgc1.336ba722.png";